import { lang } from '../resources/lang';
import { CustomError } from './CustomError';
import { LiquidHttpRequestError } from './LiquidHttpRequestError';
import { notify } from './notify';
import { urls } from './urls';

export const common = {

  headerAndContextBarHeight: 110,

  headerAndContextBarHeightAndTableHeaderToolbar: 243,

  headerAndContextBarHeightAndTableHeaderInfo: 254,

  headerAndContextBarHeightAndTableHeaderInfoAndButtons: 283,

  headerAndContextBarHeightAndViewerPageTools: 160,

  headerAndContextBarHeightAndViewerPageToolsEmbed: 186,

  headerAndContextBarHeightAndDetailTabHeaderForm: 292,

  headerAndContextBarHeightAndIndexerPageTools: 167,

  loading: {

    idDOM: 'loader',

    element: function () {

      return jQuery('<div class="' + common.loading.idDOM + '"></div>');
    }

  },

  openLoadingFullPage: function () {
    let $loadDiv = jQuery('<div class="fullpageload"><div class="loader-fullpage"></div></div>');
    jQuery('body').append($loadDiv);
  },

  closeLoadingFullPage: function () {
    jQuery('body').find('.fullpageload').remove();
  },

  openLoadingModal: function () {
    let $loadDiv = jQuery('<div class="fullpageload modal"><div class="loader-fullpage"></div></div>');
    $('.modal-content').append($loadDiv);
  },

  closeLoadingModal: function () {
    jQuery('.fullpageload.modal').remove();
  },

  errorHandler: function (error) {

     if (error.errorCode === 401) {
      window.location.href = urls.user.urlLogOutExpiredSession;
    }

    if (error instanceof CustomError) {
      if (error.content.message) {
        notify.danger("Ocorreu um problema", error.content.message, false);
      }
      else {
        notify.danger("Ocorreu um problema", "Erro não identificado - Entre em contato com o suporte do Liquid Suite", false);
      }
    }
    else if (error instanceof LiquidHttpRequestError) {

        if (error.message) {
            notify.danger("Ocorreu um problema", error.message, false);
            return;
        }

        if (error.content?.message) {
          notify.danger("Ocorreu um problema", error.content.message, false);
          return;
        }

        notify.danger("Ocorreu um problema", "Erro na comunicação com o servidor", false);
        return;
    }
    else if (error instanceof Error) {

        if (error.message) {
          notify.danger("Ocorreu um problema", error.message, false);
          return;
        }

        notify.danger("Ocorreu um problema", 'Erro inesperado na aplicação.', false);
        return;
    }
    else {
      // string pura
      if (typeof error === 'string') {
        notify.danger("Ocorreu um problema", error, false);
        return;
      }

      // objeto qualquer vindo de algum lugar estranho
      if (typeof error === 'object') {

          if (error.message) {
            if (error.message === "Unexpected token '<', \"<!DOCTYPE \"... is not valid JSON") {
              window.location.href = urls.user.urlLogOutExpiredSession;
            }
            notify.danger("Ocorreu um problema", error.message, false);
            return;
          }

          try {
            notify.danger("Ocorreu um problema", JSON.stringify(error), false);
            return;
          } catch {
            notify.danger("Ocorreu um problema", 'Erro inesperado.', false);
            return;
          }
      }

      notify.danger("Ocorreu um problema", "Erro não identificado - Entre em contato com o suporte do Liquid Suite", false);
      return;
      
    }

  },

  permission: {

    object: {

      wardrobe: {

        WardrobeCreate: 1,
        WardrobeRename: 2,
        WardrobeDelete: 4,
        WardrobeManageRoles: 8,
        WardrobeReadProperties: 16,
        FolderCreate: 32

      },

      folder: {

        FolderCreate: 1,
        FolderRename: 2,
        FolderDelete: 4,
        FolderManageRoles: 8,
        FolderSearch: 16,
        FolderExport: 32,
        FolderSign: 64,
        FolderSubsForm: 128,
        FolderProcessOCR: 256,
        FolderReadProperties: 512,
        DocumentCreate: 1024,
        FolderCopyTo: 2048,
        FolderMoveTo: 4096,
        FolderEditMonitor: 8192,
        FolderReadAuditAccess: 16384

      },

      document: {

        DocumentRename: 1,
        DocumentDelete: 2,
        DocumentExport: 4,
        DocumentManageRoles: 8,
        DocumentReadProperties: 16,
        DocumentCopyTo: 32,
        DocumentImportTo: 64,
        DocumentPrint: 128,

        DocumentSign: 256,
        DocumentMarcaDagua: 512,
        DocumentProcessOCR: 1024,
        DocumentViewForm: 2048,
        DocumentEditForm: 4096,
        DocumentSubsForm: 8192,
        DocumentMoveTo: 16384,
        PageCreate: 32768,

        PageEdit: 65536,
        PageDelete: 131072,
        PageExport: 262144,
        PageViewAnnotation: 524288,
        PageCreateAnnotation: 1048576,
        PageDeleteAnnotation: 2097152,
        PageInsertMark: 4194304,
        PageViewWithouttMark: 8388608,

        PageProcessOCR: 16777216,
        PageViewOCR: 33554432,
        PageEditOCR: 67108864,
        DocumentReplace: 134217728,
        DocumentEditTemporality: 268435456,
        PageClassify: 536870912,
        DocumentShare: 1073741824,
        PageConvert: 2147483648
      },

      documentExtend: {

        DocumentAiChat : 1,

      }

    },

    system: {

      Access: 1,
      Search: 2,
      CreateWardrobe: 4,
      ReportInfoSystem: 8,
      ReportActivity: 16,
      ReportError: 32,
      ConfigForm: 64,
      ConfigImportPerfil: 128,
      
      ConfigVolume: 256,
      ConfigGroup: 512,
      ConfigUser: 1024,
      ConfigRoleSystem: 2048,
      ConfigRoleObjects: 4096,
      ConfigWaterMark: 8192,
      ConfigTemporalidade: 16384,
      ConfigSessions: 32768,
      
      Index: 65536,
      ConfigAuthApplication: 131072,
      ConfigLiquidSuite: 262144,
      ConfigIntegrations: 524288,
      EditUserProfile: 1048576,
      ExportSearch: 2097152,
      ReportOCR: 4194304,
      ConfigCertification: 8388608,
      
      ReportTemporality: 16777216,
      ReportUserGroupPermissions: 33554432,
      CertificateDocs: 67108864,
      AiChatDocument: 134217728,
      AiChatOracle: 268435456,
      WorkflowManage: 536870912,

    }

  },

  gridElements: {

    button: function (classname, label, fn) {
      var $button = $('<button class="btn" type="button"></button>');
      $button.addClass(classname);
      $button.html(label.toUpperCase());
      if (fn !== undefined) {
        $button.on('click', fn);
      }
      return $button;
    },

    tableHeadItem: function (classname, label, fn) {
      var $div = $('<div></div>', { "class": classname });
      $div.html(label);
      if (fn !== undefined) {
        $div.on('click', fn);
      }
      return $div;
    },

    tableFooterLabel: function (page, total) {

      var $divpagelabel = $('<div id="page-label"></div>');
      $divpagelabel.html(lang.page + " " + page + " " + lang.of + " " + total);
      return $divpagelabel;

    },

    gridStatusHeader: function (gridData) {

      if (gridData.page === 1 && gridData.total === 0) {

        return $('<div style="text-align: left; font-weight: 700; padding: 10px 0px;">' + lang.noRecordsFind + '</div>');

      }
      else {

        var $gridNavResults = $('<div style="text-align: left; font-weight: 700; padding: 10px 0px;"></div>');
        $gridNavResults.append(gridData.records + ' ' + lang.recordsFind);
        return $gridNavResults;

      }

    },

    gridStatusHeaderSearch: function (gridData) {

      if (gridData.page === 1 && gridData.total === 0) {

        return $('<div style="text-align: left; font-weight: 700; padding: 10px 0px;">' + lang.noRecordsFind + '</div>');

      }
      else {

        var $gridNavResults = $('<div style="text-align: left; font-weight: 700; padding: 10px 0px; display: flex; min-height: 42px;"></div>');
        $gridNavResults.append('<span style="flex: 1;">' + gridData.records + ' ' + lang.recordsFind + '</span>');
        return $gridNavResults;

      }

    }

  },

  caller: {

    files: 1,
    viewer: 2,
    search: 3,
    report: 4,
    setting: 5

  },

  formatCPF: function (value) {
    return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3\-\$4");
  },

  formatCNPJ: function (value) {
    return value.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3\/\$4\-\$5");
  },

  formatCampoValue: function (dado) {
    let valor = null;
    if (dado.tipo === 1) {
      valor = (dado.valor === null || dado.valor === undefined) ? null : '' + dado.valor;
    }
    else if (dado.tipo === 3) {
        valor = (dado.valor === null || dado.valor === undefined) ? null : common.formatCPF(dado.valor);
    }
    else if (dado.tipo === 4) {
        valor = (dado.valor === null || dado.valor === undefined) ? null : common.formatCNPJ(dado.valor);
    }
    else if (dado.tipo === 7) {
      valor = (dado.valor === null || dado.valor === undefined) ? null : '' + dado.valor;
    }
    else if (dado.tipo === 8) {
        if (dado.valor !== null && dado.valor !== undefined) {
            valor = "";
            dado.valor.forEach(function (elMultiple) {
                valor = valor + elMultiple + "|";
            });
            if (valor.length > 0) {
                valor = valor.substring(0, valor.length - 1);
            }
        }
    }
    else if (dado.tipo === 9) {
        valor = (dado.valor === null || dado.valor === undefined) ? null : common.formatDateValue(dado.valor);
    }
    else if (dado.tipo === 10) {
      valor = (dado.valor === null || dado.valor === undefined) ? null : '' + dado.valor;
    }
    else {
        valor = dado.valor;
    }
    if (valor === 'null') {
        valor = null;
    }
    return valor === undefined ? null : valor;
  },

  formatDateValue: function (value) {
    if (common.isDateNormalFormat(value)) {
        return moment(common.convertNormalDate(value)).format("YYYY-MM-DD") + "T00:00:00";
    }
    else {
        if (value !== undefined && value !== "" && moment(value).isValid()) {
            return moment(value).format("YYYY-MM-DD") + "T00:00:00";
        }
    }
    return null;
  },

  isDateNormalFormat: function (value) {
    let regex = /^(((0[1-9]|[12]\d|3[01])\/(0[13578]|1[02])\/((19|[2-9]\d)\d{2}))|((0[1-9]|[12]\d|30)\/(0[13456789]|1[012])\/((19|[2-9]\d)\d{2}))|((0[1-9]|1\d|2[0-8])\/02\/((19|[2-9]\d)\d{2}))|(29\/02\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/g;
    return regex.test(value);
  },

  convertNormalDate: function(value) {
    let values = value.split('/');
    let day = parseInt(values[0]);
    let mounth = parseInt(values[1]) - 1;
    let year = parseInt(values[2]);

    return new Date(year, mounth, day);
  },

  formatDateTime: function (value) {

    if (value === null || value === undefined) {
      return "-";
    }

    var dateObj = new Date(value);

    var day = ("0" + dateObj.getDate()).slice(-2);
    var mouth = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    var year = dateObj.getFullYear();

    return day + "/" + mouth + "/" + year
  },

  formatDateTimeHour: function (value) {

    var dateObj = new Date(value);

    var day = ("0" + dateObj.getDate()).slice(-2);
    var mouth = ("0" + (dateObj.getMonth() + 1)).slice(-2);
    var year = dateObj.getFullYear();

    var hour = ("0" + dateObj.getHours()).slice(-2);
    var minute = ("0" + dateObj.getMinutes()).slice(-2);
    var seconds = ("0" + dateObj.getSeconds()).slice(-2);

    return day + "/" + mouth + "/" + year + " " + hour + ":" + minute + ":" + seconds;
  },

  getTimeString: function (value) {

    if (value === 0) {
      return '000000';
    }
    else if ((value % 2) === 0) {
      let valueReturn = (value / 2);
      return ("0" + valueReturn).slice(-2) + '0000';
    }
    else {
      value = value - 1;
      let valueReturn = (value / 2);
      return ("0" + valueReturn).slice(-2) + '3000';
    }
  },

  setTheme: function (theme) {
    let root = document.querySelector(':root');
    if (theme === 'red') {
      root.style.setProperty('--color-primary-lssuite', '#B61918');
      root.style.setProperty('--color-secondary-lssuite', '#E30513');
      root.style.setProperty('--color-menu-principal-item-a', '#dadada');
      root.style.setProperty('--color-menu-principal-select-back', '#4a1414');
      root.style.setProperty('--color-menu-principal-disabled', '#411a0e');
      root.style.setProperty('--color-btn-details-color-on', '#981615');
      root.style.setProperty('--color-btn-details-color-off', '#B61918');
      root.style.setProperty('--color-btn-details-color-border', '#4f0d0c');
      root.style.setProperty('--color-principal-links', '#575756');
      root.style.setProperty('--color-principal-links-hover', '#727272');
      root.style.setProperty('--color-btn-principal-border', '#404040');
      root.style.setProperty('--color-btn-principal-border-hover', '#656565');
      root.style.setProperty('--color-jstree-icon', '#7b7b7a');
      root.style.setProperty('--color-jstree-selected', '#575756');
      root.style.setProperty('--color-login-principal', '#ffffff');
      root.style.setProperty('--color-miniatura-background', '#E30513');
      root.style.setProperty('--color-login-input', '#C8D0D8');
      root.style.setProperty('--color-login-input-border', '#C8D0D8');
      root.style.setProperty('--color-login-input-border-focus', '#ffffff');
      root.style.setProperty('--color-login-input-checkbox', '#9e0b10');
      root.style.setProperty('--color-login-input-checkbox-border', '#fff');
      root.style.setProperty('--color-login-input-error', '#dcd1d1');
      root.style.setProperty('--color-login-msg-error', '#d2d2d2');
      root.style.setProperty('--login-screen', "url('/images/login/login-tela-red.png')");
    }
    else if (theme === 'orange') {
      root.style.setProperty('--color-primary-lssuite', '#D66F3E');
      root.style.setProperty('--color-secondary-lssuite', '#562C19');
      root.style.setProperty('--color-menu-principal-item-a', '#A5927B');
      root.style.setProperty('--color-menu-principal-select-back', '#381C10');
      root.style.setProperty('--color-menu-principal-disabled', '#411a0e');
      root.style.setProperty('--color-btn-details-color-on', '#9e4e0a');
      root.style.setProperty('--color-btn-details-color-off', '#b76839');
      root.style.setProperty('--color-btn-details-color-border', '#8a450a');
      root.style.setProperty('--color-principal-links', '#D07412');
      root.style.setProperty('--color-principal-links-hover', '#e47f14');
      root.style.setProperty('--color-btn-principal-border', '#a25f37');
      root.style.setProperty('--color-btn-principal-border-hover', '#7d4828');
      root.style.setProperty('--color-jstree-icon', '#A5927B');
      root.style.setProperty('--color-jstree-selected', '#D07412');
      root.style.setProperty('--color-login-principal', '#D07412');
      root.style.setProperty('--color-miniatura-background', '#D07412');
      root.style.setProperty('--color-login-input', '#C8D0D8');
      root.style.setProperty('--color-login-input-border', '#9E9E9E');
      root.style.setProperty('--color-login-input-border-focus', '#D66F3E');
      root.style.setProperty('--color-login-input-checkbox', '#3c1f11');
      root.style.setProperty('--color-login-input-checkbox-border', '#fff');
      root.style.setProperty('--color-login-input-error', '#DC6464');
      root.style.setProperty('--color-login-msg-error', '#ff6161');
      root.style.setProperty('--login-screen', "url('/images/login/login-tela-orange.png')");
    }
    else {
      root.style.setProperty('--color-primary-lssuite', '#24ADB8');
      root.style.setProperty('--color-secondary-lssuite', '#1B3C5D');
      root.style.setProperty('--color-menu-principal-item-a', '#7D93A8');
      root.style.setProperty('--color-menu-principal-select-back', '#0E2032');
      root.style.setProperty('--color-menu-principal-disabled', '#0E2841');
      root.style.setProperty('--color-btn-details-color-on', '#0A939E');
      root.style.setProperty('--color-btn-details-color-off', '#39aeb7');
      root.style.setProperty('--color-btn-details-color-border', '#0A808A');
      root.style.setProperty('--color-principal-links', '#4284F4');
      root.style.setProperty('--color-principal-links-hover', '#3581FF');
      root.style.setProperty('--color-btn-principal-border', '#3D74D0');
      root.style.setProperty('--color-btn-principal-border-hover', '#2B58A4');
      root.style.setProperty('--color-jstree-icon', '#7D93A8');
      root.style.setProperty('--color-jstree-selected', '#4488D8');
      root.style.setProperty('--color-login-principal', '#83A2C0');
      root.style.setProperty('--color-miniatura-background', '#4284F4');
      root.style.setProperty('--color-login-input', '#C8D0D8');
      root.style.setProperty('--color-login-input-border', '#9E9E9E');
      root.style.setProperty('--color-login-input-border-focus', '#24ADB8');
      root.style.setProperty('--color-login-input-checkbox', '#132941');
      root.style.setProperty('--color-login-input-checkbox-border', '#fff');
      root.style.setProperty('--color-login-input-error', '#DC6464');
      root.style.setProperty('--color-login-msg-error', '#ff6161');
      root.style.setProperty('--login-screen', "url('/images/login/login-tela.png')");
    }
  },

  compileAngular: function (elementId, jsonData) {

    var htmlPartialView = angular.element(document.getElementById(elementId)).scope().compilePartialView(jsonData.htmlContent);
    angular.element(htmlPartialView[0]).scope().$apply();
    return htmlPartialView;

  },

  handlerErrorResponse: function (response) {
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      return response.json().then((contentError) => {
        throw new CustomError(response.statusText, response.status, contentError);
      });
    } else {
      return response.text().then((contentError) => {
        throw new CustomError(response.statusText, response.status, contentError);
      });
    }
  },

  handlerLiquidHttpErrorResponse: async function (response) {

    const contentType = response.headers.get("content-type") || '';

    let content = null;
    let rawText = null;

    try {

        if (contentType.includes("application/json")) {
            content = await response.json();
        }
        else {
            rawText = await response.text();

            content = {
                message: common.getFriendlyHttpErrorMessage(response, rawText),
                raw: rawText
            };
        }
    } catch (e) {

        content = {
            message: common.getFriendlyHttpErrorMessage(response, null),
            raw: null,
            parseError: e
        };
    }

    throw new LiquidHttpRequestError(response, content);
  },

  getFriendlyHttpErrorMessage: function (response, rawText) {

      if (response.status === 0) {
          return 'Não foi possível conectar ao servidor.';
      }

      if (response.status === 400) {
          return 'A requisição não pôde ser processada.';
      }

      if (response.status === 401) {
          return 'Sua sessão expirou ou o acesso não foi autorizado.';
      }

      if (response.status === 403) {
          return 'Você não possui permissão para executar esta ação.';
      }

      if (response.status === 404) {
          return 'O recurso solicitado não foi encontrado.';
      }

      if (response.status === 408) {
          return 'A requisição demorou demais para responder.';
      }

      if (response.status === 413) {
          return 'O arquivo ou conteúdo enviado é maior que o limite permitido.';
      }

      if (response.status === 500) {
          return 'Ocorreu um erro interno no servidor.';
      }

      if (response.status === 502 || response.status === 503 || response.status === 504) {
          return 'O serviço está temporariamente indisponível.';
      }

      if (rawText && rawText.trim().startsWith('<')) {
          return 'O servidor retornou uma página de erro inesperada.';
      }

      return response.statusText || 'Erro inesperado na requisição.';
  },

  getErrorMessage: function (error) {

    if (!error) {
        return 'Erro desconhecido.';
    }

    // seu erro HTTP padronizado
    if (error instanceof LiquidHttpRequestError) {

        if (error.message) {
            return error.message;
        }

        if (error.content?.message) {
            return error.content.message;
        }

        return 'Erro na comunicação com o servidor.';
    }

    // erro padrão JS
    if (error instanceof Error) {

        if (error.message) {
            return error.message;
        }

        return 'Erro inesperado na aplicação.';
    }

    // string pura
    if (typeof error === 'string') {
        return error;
    }

    // objeto qualquer vindo de algum lugar estranho
    if (typeof error === 'object') {

        if (error.message) {
            return error.message;
        }

        try {
            return JSON.stringify(error);
        } catch {
            return 'Erro inesperado.';
        }
    }

    return 'Erro inesperado.';
  }

};
